<pdf-viewer [src]="documentUrl()" [render-text]="true" style="display: block;"></pdf-viewer>
